module.exports = __webpack_public_path__ + "static/media/space-rays.8703d00a.jpg";